<template>
  <div class="main">
    <div class="tent">
      <div class="box">
        <div class="box-a">
          <img src="../assets/logo.png">
        </div>
        <div class="box-b">
          <ul>
            <li><a @click="handleRouter">首页</a></li>
            <li><a @click="handleRouter1">产品&服务</a></li>
            <li><a @click="handleRouter2">成功案例</a></li>
            <li><a @click="handleRouter3">关于我们</a></li>
          </ul>
        </div>
      </div>
      <div><slide-show :slides="slides" :inv="invTime"></slide-show></div>
<!--      <div><img src="../assets/banner2.png"></div>-->
    </div>
    <div class="down">
      <img src="../assets/cpfuss.png">
    </div>
    <div class="footer">
      <img src="../assets/db.jpg">
    </div>
    <div class="nn">
      <p>电话：15823928771（微信同号）</p>
      <p>邮箱：3566564629@qq.com</p>
      <p>QQ：3566564629</p>
      <p>地址：重庆市沙坪坝区景阳路光谷·智创园B座4楼</p>
      <p style="margin-left: 530px"> <a href="http://beian.miit.gov.cn" target="_blank">渝ICP备17012699号-1</a></p>
    </div>
  </div>
</template>

<script>
    import slideShow from "../components/slideShow";

    export default {
        name: "Service",
      components: {
        slideShow
      },

      data() {
        return{
          invTime: 2000,
          slides: [
            {
              src: require('../assets/banner2.png'),
            },
            {
              src: require('../assets/banner3.png'),
            },
            {
              src: require('../assets/banner1.png'),
            },
            {
              src: require('../assets/banner4.png'),
            }
          ],
        }
      },
      methods: {
        handleRouter(){
          this.$router.push('/')
        },
        handleRouter1(){
          this.$router.push('/Service')
        },
        handleRouter2(){
          this.$router.push('/Case')
        },
        handleRouter3(){
          this.$router.push('/We')
        },
      },
    }
</script>
<style scoped>

  .main{
    width: 100%;
  }
  .footer{
    margin-top: -5px;
    /*background: url("../assets/底部.jpg");*/
  }
  .footer img{
    max-height: 100%;
    max-width: 100%;
  }
  .tent{
    width: 100%;
    position:relative;


    /*margin-top: -15px;*/
    /*margin-bottom: -40px;*/

  }
  .tent .box{
    width: 100%;
    height:60px;
    line-height:60px;
    /*background: url("../assets/top.png") no-repeat ;*/
    background-color: #2c3e50;
    z-index: 999;
    position:absolute;
    background-color:rgba(0,0,0,0.4);
  }
  .tent .box .box-a{
    width: 50%;
    height: 70px;
    float: left;
  }
  .tent .box .box-a img{
    float: right;
    width: 50%;
    margin-right:14%;
    margin-top: 15px;
  }
  .tent .box .box-b {
    width: 50%;
    height: 70px;
    float: right;
  }
  .tent .box .box-b ul {
    position: relative;
    margin: 0 auto;
    height: 70px;
    width: 50%; }
  .tent .box .box-b li {
    float: left;
    margin-right: 0px;
    width: 25%;
    height: 70px; }
  li {
    list-style: none;
    min-width: 10px;
  }
  a {
    font-style: normal;
    position: relative;
    color: #efefef;
    text-align: center;
    text-decoration: none;
    display: block;
    z-index: 200 }
  a:hover{
    color:#32bec3;
  }

  .tent img{
    width: 100%;
  }
  .down{
    width: 100%;
/*margin-top: -10px;*/
  }
  .down img{
    width: 100%;
  }

  .bottom img{

  }
  .left{
    float: left;
    width: 25%;
    padding-top: 115px;
    text-align: left;
    margin-left: 20%;
  }
  .left p{
    margin-top: 15px;
  }
  .right{
    float: right;
    width: 50%;
    padding-top: 130px;
  }
  .right img{
    width: 100px;
    height: 100px;
  }
  .nn{
    z-index: 999;
    margin-top: -170px;
    color: white;
    text-align: left;
    margin-left: 350px;
  }
  .nn p{
    margin-top: -5px;
  }
  .nn a{
    text-decoration: none;
    text-align: left;
  }
  .nn a:hover{
    color:#32bec3;
  }
</style>



// WEBPACK FOOTER //
// src/page/Service.vue